import { Country, useCountry } from 'src/components/Context/CountryContext';

export const useShouldHideForCountry = (countryKey: Country): boolean => {
  const { country } = useCountry();
  if (!country) return false;

  return countryKey !== country;
};